import CompositionsService from '@/services/Compositions/CompositionsService';

const state = {
  data: [],
  companyCompositions: [],
  current: {
    name: '',
    human_name: '',
    additives_percentage: 0,
    other_percentage: 0,
    materials: []
  }
};

function parseCurrentCompositionData(currentState) {
  const t = deepCopy(currentState);
  t.company_id = t.company.id;
  delete t.company;

  t.materials = t.materials.filter(e => {
    if (typeof e.sub_composition_id !== 'undefined' && e.sub_composition_id) {
      if (typeof e.checked !== 'undefined') {
        return e.checked;
      }
      return false;
    }
    return true;
  });

  return t;
}

const actions = {
  getCompositions({commit}) {
    return CompositionsService.getCompositions().then(result => {
      commit('setData', result.data);
    });
  },
  companyCompositions({commit}, companyId) {
    return CompositionsService.getCompositions(companyId).then(result => {
      commit('companyCompositions', result.data);
    });
  },
  save () {
    // const t = deepCopy(state.current);
    // t.company_id = t.company.id;
    // delete t.company;

    // t.materials = t.materials.filter(e => {
    //   if (typeof e.sub_composition_id !== 'undefined' && e.sub_composition_id) {
    //     if (typeof e.checked !== 'undefined') {
    //       return e.checked;
    //     }
    //     return false;
    //   }
    //   return true;
    // });
    const t = parseCurrentCompositionData(state.current);
    if (state.current.id) {
      return CompositionsService.editComposition(state.current.id, t).then(() => {
        //commit('setData', result.data);
      });
    }
    else {
      return CompositionsService.createComposition(t).then(() => {
        //commit('setData', result.data);
      });
    }
  },
  current ({commit}, data) {
    commit('current', data);
  },
  removeOther ({commit}, data) {
    commit('removeOther', data);
  },
  addOther ({commit}) {
    commit('addOther');
  },
  remove (_, id) {
    return CompositionsService.removeComposition(id).then(() => {
      // commit('remove');
    });

  }
};

const mutations = {
  setData(state, data) {
    state.data = data;
  },
  current(state, data) {
    state.current = data;
  },
  setCurrentCompositionCompany(state, company) {
    state.current.company = company;
  },
  removeOther(state, data) {
    state.current.materials = state.current.materials.filter(e => e !== data);
  },
  addOther(state) {
    if (typeof state.current.materials === 'undefined') {
      state.current.materials = [];
    }
    state.current.materials.push({
      sub_composition_id: false,
      percentage: 0,
      postindustrial: 0
    });
  },
  companyCompositions (state, data) {
    state.companyCompositions = data;
  }
};

const getters = {
  data(state) {
    return state.data;
  },
  current(state) {
    return state.current;
  },
  companyCompositions (state) {
    return state.companyCompositions;
  },
  currentCompositionData(state) {
    return parseCurrentCompositionData(state.current);
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
